import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseService } from '../../base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Customer } from '../../models/customer';

@Injectable()

/**
 * CustomerService contains logic for making api requests for customers
 */
export class CustomerService extends BaseService
{
    private api: string;

	/**
	 * InvoicesService constructor
	 *
	 * @param {HttpService} http
	 */
	constructor(private http: HttpClient)
	{
		super();
		this.api = environment.api_url;
	}

    /**
	 * Makes a get request to retrieve a collection of customers
	 *
	 *
	 * @returns {Observable<Customer[]>}
	 */
	public getCustomers(): Observable<Customer>
	{
		return this.http.get(this.api + 'customers')
			.map(response => response as Customer);
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/services/customer.service.ts